<template>
  <button
    class="text-white rounded focus:outline-none focus:shadow-outline transition-all"
    :class="[themes[theme], sizes[size], spaces[space], floatedToRight ? 'float-right' : '', disabled ? 'opacity-25 cursor-not-allowed' : '']"
    :type="type"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "sp-button",

  data() {
    return {
      themes: {
        default: "",
        primary: "bg-blue hover:bg-blue-dark mb-5",
        secondary: "button--secondary",
        info: "text-blue text-sm p-0 no-underline hover:text-blue-dark",
        warning: "bg-red hover:bg-red-light",
        success: "border rounded text-green border-green hover:text-white hover:bg-green",
        danger:  "border rounded text-red border-red hover:text-white hover:bg-red",
        red:  "border rounded text-white border-red-darker bg-red-darker hover:text-red-darker hover:bg-white",
        grey: "border rounded text-grey border-grey hover:text-white hover:bg-grey",
        "blue": "font-normal text-white border border-blue bg-blue shadow-lg mx-3 hover:bg-white hover:text-blue",
        "outline-blue": "font-normal text-blue border border-blue bg-white shadow-lg mx-3 hover:bg-blue hover:text-white"
      },

      sizes: {
        none: "text-base",
        normal: "text-2sm",
        small: "text-sm",
        xsmall: "text-xs",
        large: "text-lg"
      },
      spaces: {
        none: "",
        normal: "p-4",
        small: "p-3",
        xsmall: "p-2 mx-2",
        xxsmall: "px-3 py-1 mx-2",
        large: "p-8"
      }
    };
  },

  props: {
    type: {
      required: false,
      type: String,
      default: "button"
    },

    to: {
      required: false,
      type: String | Object
    },

    href: {
      required: false,
      type: String
    },

    theme: {
      required: false,
      type: String,
      default: "default"
    },

    size: {
      required: false,
      type: String,
      default: "none"
    },
    space: {
      required: false,
      type: String,
      default: "none"
    },

    disabled: {
      required: false,
      type: Boolean,
      default: false
    },

    floatedToRight: {
      required: false,
      type: Boolean,
      default: false
    }
  }
};
</script>
